


























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';

type TimeType = 'from' | 'to';

@Component
export default class TimeOfDay extends Vue{
  @Prop({
    default: (ctx: TimeOfDay) => {
      return {
        timeOfDay: ctx.getDefaultTimeOfDay()
      };
    }
  }) conditions: any;

  predicate: string = 'EQUALS';

  from: string = '';
  to: string = '';

  getDefaultTimeOfDay() {
    return {
      predicate: 'EQUALS',
      values: {
        from: {
          hour: 0,
          minute: 0
        },
        to: {
          hour: 0,
          minute: 0
        }
      }
    }
  }

  mounted() {
    if (!this.conditions.timeOfDay) {
      this.$set(this.conditions, 'timeOfDay', this.getDefaultTimeOfDay());
    }

    this.predicate = this.conditions.timeOfDay.predicate || this.predicate;

    this.resetTime('to');
    this.resetTime('from');
  }

  get timeRegex() {
    return /^(\d{1,2}):(\d{1,2})$/;
  }

  @Watch('to')
  onToChanged(value: string){
    this.handleTimeChanged('to', value);
  }

  @Watch('from')
  onFromChanged(value: string){
    this.handleTimeChanged('from', value);
  }

  handleTimeChanged(type: TimeType, value: string) {
    let match = value.match(this.timeRegex);

    if(match) {
      let hours: number = +match[1];

      if(hours > 23) {
        hours = 23;
      } else if(hours < 0) {
        hours = 0;
      }

      let minutes: number = +match[2];

      if(minutes > 59) {
        minutes = 59;
      } else if(minutes < 0) {
        minutes = 0;
      }

      this.$set(this.conditions.timeOfDay.values[type], 'hour', hours);
      this.$set(this.conditions.timeOfDay.values[type], 'minute', minutes);
    }
  }

  resetTime(type: TimeType) {
    const subject = this.conditions.timeOfDay.values[type];
    const value = moment(`${subject.hour}:${subject.minute}`, 'HH:mm').format('HH:mm');

    switch(type) {
      case 'from':
        this.from = value;
        break;
      case 'to':
        this.to = value;
        break;
    }
  }

  @Watch('predicate')
  onPredicateChanged(value: any, oldValue: any) {
    this.$set(this.conditions.timeOfDay, 'predicate', value);
  }

  close() {
    this.$emit('close');
  }
}
